"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGenerateWebPageViewTraceId = exports.generateTraceId = void 0;
const react_1 = require("react");
const uuid_1 = require("uuid");
const web_env_1 = require("@snapchat/web-env");
function generateTraceId() {
    if (typeof (0, web_env_1.getWindow)() === "undefined") {
        return undefined;
    }
    return (0, uuid_1.v4)();
}
exports.generateTraceId = generateTraceId;
/**
 * TraceID is an identifier associated with WEB_PAGE_VIEW blizzard event which is unique for each WPV event.
 * This hook helps in generating the identifier on mount of the hook and a function to update it.
 *
 * For most use cases, having it created once on mount should be sufficient, as WPV is usually only sent on the mount of the page.
 * In some cases, consumers might want to send WPV at times other than mount (e.g. custom routing logic using React-Router or NextJS Router)
 * In these cases, since the value of traceID remains the same across re-renders, a generateNewTraceId function is exposed that helps the consumer to update the traceID
 */
function useGenerateWebPageViewTraceId() {
    // trace ID needs to be stable across component re-renders
    // useState has stronger semantics than useMemo, which doesn't offer guarantees that React won't
    // forget and re-run the computation
    // https://reactjs.org/docs/hooks-faq.html#how-to-create-expensive-objects-lazily
    const [traceId, setTraceId] = (0, react_1.useState)(generateTraceId);
    const generateNewTraceId = (0, react_1.useCallback)(() => {
        setTraceId(generateTraceId());
    }, []);
    // traceId is undefined only during SSR
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return { traceId: traceId, generateNewTraceId };
}
exports.useGenerateWebPageViewTraceId = useGenerateWebPageViewTraceId;
//# sourceMappingURL=traceId.js.map